import type { App, Directive } from 'vue'

/** 禁止 enter */

// 1️⃣ 擴展 `HTMLElement`，增加 `_disableEnterHandler` 屬性
interface HTMLElementWithHandler extends HTMLElement {
  _disableEnterHandler?: (event: KeyboardEvent) => void
}

// 2️⃣ `mounted`：在元素掛載時綁定 `keydown` 事件
const mounted = (el: HTMLElementWithHandler) => {
  el._disableEnterHandler = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      const collapseItem = (event.target as HTMLElement).closest('.el-collapse-item')
      if (collapseItem) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  }

  document.addEventListener('keydown', el._disableEnterHandler, true)
}

// 3️⃣ `unmounted`：當元素卸載時移除 `keydown` 事件，避免內存洩漏
const unmounted = (el: HTMLElementWithHandler) => {
  if (el._disableEnterHandler) {
    document.removeEventListener('keydown', el._disableEnterHandler, true)
    delete el._disableEnterHandler
  }
}

// 4️⃣ 封裝 Vue 指令
const disableEnterDirective: Directive = {
  mounted,
  unmounted
}

// 5️⃣ 提供全局註冊函數
export const setupDisableEnterDirective = (app: App<Element>) => {
  app.directive('disable-enter', disableEnterDirective)
}

// 6️⃣ 預設導出指令
export default disableEnterDirective
